/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { TableCourier } from "./components/TableCourier"
import { OrdersContext } from "../../context/OrdersContext";
import { Col } from "antd";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";

import { getAuth } from "firebase/auth";

export const BoardCourier = () => {
    const [userData, setUserData] = useState()
    const db = getFirestore();
    const auth = getAuth();
    const user = auth.currentUser?.email;    
    // Obtener los documentos que coinciden con la consulta
    useEffect(() => {
        const usersCollection = collection(db, 'user');
        const userQuery = query(usersCollection, where('email', '==', user));

        // Obtener los documentos que coinciden con la consulta
        getDocs(userQuery)
          .then((querySnapshot) => {
            if (querySnapshot) {
              querySnapshot.forEach((doc) => {
                const userData = doc.data();
                setUserData(userData);
              });
            } else {
              console.log('No se encontraron usuarios con ese correo electrónico.');
            }
          })
          .catch((error) => {
            console.error('Error al buscar el usuario:', error);
          });
    }, []);

    const { 
        dataOrders,
      } = useContext(OrdersContext);

      const dataFilter = (userData && userData.courier) 
      ? dataOrders.filter(order => order.courier.toUpperCase() === userData.courier.toUpperCase())
      : dataOrders;
  
    return (
        <div className="mx-auto my-6">
            <div className="grid-rows-custom grid-cols-custom gap-x-0 gap-y-0 w-full">
                <Col className="my-4" xs={24} sm={24} md={24} lg={24} xl={24}>
                    <TableCourier db={db} title={userData ? userData.courier : "Admin"} role={userData ? userData.role : "Undefined"} data={dataFilter}/>
                </Col>
            </div>
        </div>
    )
}